// @file Entry-point for AuthLoggedOutApp
import window from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import App from '@@/vuecomponents/AuthLoggedOutApp.vue'

void setupVueApp({
  el: '#auth_logged_out',
  rootComponent: App,
  rootComponentProps: () => {
    return window.ww.vueStartingState
  },
  usePinia: true,
})
